import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.translation.json",
    },

    // Add namespaces here for different sections of module
    ns: ["common", "dashboard", "report"],
    defaultNS: "common",

    supportedLngs: ["en", "ja", "zh-TW", "zh-CN", "it", "de", "th", "ko"],
    fallbackLng: "en",

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
